const mediaItems = [
  {
    title: '《狂飙》高能片段：高启强巅峰演技时刻',
    duration: '05:32',
    views: '128万',
    imgUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20from%20Chinese%20crime%20drama%20with%20intense%20actor%20performance%2C%20dark%20interrogation%20room%20setting%20with%20harsh%20lighting%2C%20two%20men%20facing%20each%20other%2C%20cinematic%20lighting%20with%20strong%20shadows%2C%20tense%20atmosphere%2C%20film%20still%20quality&width=800&height=450&seq=media-1-kuangbiao&orientation=landscape',
  },
  {
    title: '《三体》名场面：古筝行动视觉解析',
    duration: '08:15',
    views: '96万',
    imgUrl: 'https://readdy.ai/api/search-image?query=Science%20fiction%20scene%20with%20futuristic%20technology%20and%20cosmic%20background%2C%20dramatic%20visual%20effects%20showing%20space%20phenomenon%2C%20dark%20and%20mysterious%20atmosphere%2C%20nanotechnology%20wire%20concept%20visual%2C%20cinematic%20sci-fi%20aesthetic%2C%20epic%20scale&width=800&height=450&seq=media-2-threebody&orientation=landscape',
  },
  {
    title: '《莲花楼》打戏集锦：成毅武打身段绝美',
    duration: '04:48',
    views: '87万',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20elegant%20sword%20fighting%2C%20flowing%20silk%20costumes%20in%20motion%2C%20traditional%20Chinese%20architecture%20background%2C%20dynamic%20action%20pose%2C%20beautiful%20cinematography%20with%20natural%20lighting%2C%20wuxia%20aesthetic&width=800&height=450&seq=media-3-lotus&orientation=landscape',
  },
  {
    title: '《漫长的季节》结局解读：细节与隐喻',
    duration: '06:20',
    views: '73万',
    imgUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20autumn%20scene%20in%20northern%20Chinese%20industrial%20town%2C%20golden%20leaves%20falling%2C%20lonely%20figure%20walking%20on%20railway%20tracks%2C%20melancholic%20and%20beautiful%20atmosphere%2C%20cinematic%20color%20grading%20with%20warm%20amber%20tones&width=800&height=450&seq=media-4-longseason&orientation=landscape',
  },
  {
    title: '《封神第一部》幕后特辑：视觉特效揭秘',
    duration: '10:05',
    views: '65万',
    imgUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20film%20behind%20the%20scenes%20with%20green%20screen%20studio%20and%20costume%20details%2C%20ancient%20warrior%20armor%20closeup%2C%20professional%20film%20production%20environment%2C%20dramatic%20lighting%20on%20set%2C%20grand%20scale%20production%20design&width=800&height=450&seq=media-5-fengshen&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              精彩片段
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              热门影视高光时刻，一睹为快
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden relative">
                  <img
                    src={item.imgUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                      <i className="ri-play-fill text-xl md:text-2xl text-foreground-900 group-hover:text-white ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    <span>{item.views}次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}